import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const HomePage: React.FC = () => {
    const [roomCode, setRoomCode] = useState('');
    const [hostName, setHostName] = useState('');
    const navigate = useNavigate();

    const createRoom = () => {
        if (hostName.trim()) {
            // Geçici olarak rastgele oda kodu oluşturuyoruz
            const newRoomCode = Math.random().toString(36).substring(2, 8).toUpperCase();
            navigate(`/room/${newRoomCode}?host=${encodeURIComponent(hostName)}`);
        }
    };

    const joinRoom = () => {
        if (roomCode.trim()) {
            navigate(`/join?room=${roomCode.toUpperCase()}`);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center px-4 py-8">
            <div className="max-w-md w-full text-center">
                <h1 className="text-4xl sm:text-6xl font-bold text-white mb-2">WORDLE</h1>
                <p className="text-lg sm:text-xl text-gray-300 mb-8">Grup Oyunu</p>

                <div className="bg-gray-800 rounded-lg p-8 space-y-6">
                    <div>
                        <h2 className="text-2xl font-semibold text-white mb-4">Oyun Kuralları</h2>
                        <ul className="text-gray-300 text-left space-y-2">
                            <li>• Host 5 harfli bir kelime belirler</li>
                            <li>• Diğer oyuncular 6 denemede kelimeyi bulur</li>
                            <li>• Yeşil: Doğru harf, doğru pozisyon</li>
                            <li>• Sarı: Doğru harf, yanlış pozisyon</li>
                            <li>• Gri: Harf kelimede yok</li>
                            <li>• Host kelimeyi görebilir, diğerleri tahmin eder</li>
                        </ul>
                    </div>

                    <div className="space-y-4">
                        <div>
                            <label className="block text-white text-sm font-medium mb-2">
                                Host Adınız
                            </label>
                            <input
                                type="text"
                                value={hostName}
                                onChange={(e) => setHostName(e.target.value)}
                                placeholder="Adınızı girin"
                                className="w-full px-4 py-3 bg-gray-700 text-white rounded-lg border border-gray-600 focus:border-wordle-green focus:outline-none mb-4"
                                maxLength={20}
                            />
                        </div>
                        <button
                            onClick={createRoom}
                            disabled={!hostName.trim()}
                            className="w-full bg-wordle-green hover:bg-green-600 disabled:bg-gray-600 disabled:cursor-not-allowed text-white font-semibold py-3 px-6 rounded-lg transition-colors"
                        >
                            Yeni Oda Oluştur
                        </button>

                        <div className="flex space-x-2">
                            <input
                                type="text"
                                value={roomCode}
                                onChange={(e) => setRoomCode(e.target.value.toUpperCase())}
                                placeholder="Oda kodu girin"
                                className="flex-1 px-4 py-3 bg-gray-700 text-white rounded-lg border border-gray-600 focus:border-wordle-green focus:outline-none"
                                maxLength={6}
                            />
                            <button
                                onClick={joinRoom}
                                disabled={!roomCode.trim()}
                                className="px-6 py-3 bg-wordle-yellow hover:bg-yellow-600 disabled:bg-gray-600 disabled:cursor-not-allowed text-white font-semibold rounded-lg transition-colors"
                            >
                                Katıl
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HomePage;